<div>
  <div class="ap-dialog-fullscreen--header">
    <div class="ap-dialog-fullscreen--close" mat-dialog-close [attr.data-robot-id]="data.robotId">
      Close
      <div class="ap-icon">
        <div class="close-expansion"></div>
      </div>
    </div>
  </div>
  <ap-content class="ap-dialog-fullscreen--content" [key]="data.contentId"></ap-content>
</div>
